import React from 'react';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {UsefulLinksListBox} from '../../boxes/useful-links-list/useful-links-list.box';
import {observer} from 'mobx-react';

export interface UsefulLinksListComponentProps {
    onItemClick?: () => void;
}

export const UsefulLinksListComponent = observer(
    class UsefulLinksListComponent extends OrbitComponent<UsefulLinksListComponentProps> {
        render() {
            return (
                <UsefulLinksListBox className='cy-useful-links-list'>
                    {this.services.userMenu.usefulLinks.map(li => li.render({onClick: this.props.onItemClick}))}
                </UsefulLinksListBox>
            )
        }
    }
);